export default __webpack_public_path__ + "static/media/email.67faf218.svg";